const subscriptionPageData = {
  subscriptions: [],
  recurringSubscriptions: [],
  nonRecurringSubscriptions: [],
  userPlan: null,
  errorMessage: null,
  isInApp: false
};

const pageContext = {
  robux: 'PremiumRobux',
  subscription: 'PremiumSubscriptions'
};

const errorCodes = {
  productsNotFound: 1,
  userNotFound: 10,
  userSubscriptionNotFound: 20,
  unableToCaculateRobuxGrant: 50,
  exceedRobuxGrantMax: 51
};

const events = {
  buyButtonClicked: 'Roblox.Membership.buySubscription'
};

const streamEventParams = {
  active: 'active',
  willExpire: 'will_expire',
  wantMoreBtn: 'want_more',
  robloxHelpLink: 'robux_help_page',
  learnMoreLink: 'learn_more_premium',
  getMoreLink: 'get_more_premium',
  buyBtn: 'buy'
};

const premiumFeatureType = {
  subscription: 'Subscription',
  robux: 'Robux',
  unknown: 'unknown',
  month: 'month'
};

const messages = {
  upgradeErrorTitle: 'Upgrade Unavailable',
  upgradeErrorBody:
    "We're sorry, we are unable to change your subscription as we can not currently pay out your remaining Robux balance. Please contact customer support at https://www.roblox.com/support."
};

const subscriptions = {
  RobloxPremium450: 'RobloxPremium450',
  RobloxPremium1000: 'RobloxPremium1000',
  RobloxPremium2200: 'RobloxPremium2200',
  RobloxPremium450OneMonth: 'RobloxPremium450OneMonth',
  RobloxPremium1000OneMonth: 'RobloxPremium1000OneMonth',
  RobloxPremium2200OneMonth: 'RobloxPremium2200OneMonth'
};

const firstTimeRobuxPurchasePackage = {
  FourtyRobux: '40 Robux'
};

const platformType = {
  isAndroidApp: 'isAndroidApp',
  isAmazonApp: 'isAmazonApp',
  isIosApp: 'isIosApp',
  isUwpApp: 'isUwpApp',
  isXboxApp: 'isXboxApp',
  isDesktop: 'isDesktop'
};

const viewCategories = {
  RobuxPackage: 'RobuxPackage',
  RobuxPackageCNB: 'RobuxPackageCNB'
};

const upsellTargetType = {
  asset: 'Asset',
  bundle: 'Bundle'
};

export default {
  subscriptionPageData,
  pageContext,
  errorCodes,
  events,
  streamEventParams,
  premiumFeatureType,
  messages,
  subscriptions,
  firstTimeRobuxPurchasePackage,
  platformType,
  viewCategories,
  upsellTargetType
};
